module.exports = __webpack_public_path__ + "static/media/h2-compliance.95bcbfaa.jpg";